import type { FileMeta } from '@jotta/utils/files'
import { getFilesFromDataTransferItemList } from '@jotta/utils/files'

import { useGlobalPasteListener } from './useGlobalPasteListener'

export function useGlobalFilePasteListener(
  onPaste: (file: FileMeta[]) => void,
  onError: (path: string[]) => void,
) {
  useGlobalPasteListener(async event => {
    const items = event.clipboardData?.items
    if (items) {
      const files = await getFilesFromDataTransferItemList(items, onError)
      if (files.length) {
        onPaste(files)
      }
    }
  })
}
